export default "__VITE_ASSET__Cp3c518$__"